// primer is a baseline CSS library that sets up Opendoor defaults
import React from 'react';
import { createRoot } from 'react-dom/client';

import { ApolloProvider } from '@apollo/client';
import '@blueprintjs/core/lib/css/blueprint.css';
import { loadSentry } from '@opendoor/observability';
import '@opendoor/primer/stylesheets/primer.css';
import '@opendoor/silica/dist/mosaic.css';
import '@opendoor/silica/dist/mosaic.css';

import App from './App';
import { clientFromUrl } from './setupAthenaClient';

loadSentry('https://93118d4616254e849677af1460d826ad@o117144.ingest.sentry.io/6058924');

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ApolloProvider client={clientFromUrl()}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
);
